import { render, staticRenderFns } from "./ActiveTasksList.vue?vue&type=template&id=20896ae6&scoped=true"
import script from "./ActiveTasksList.vue?vue&type=script&lang=js"
export * from "./ActiveTasksList.vue?vue&type=script&lang=js"
import style0 from "./ActiveTasksList.vue?vue&type=style&index=0&id=20896ae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20896ae6",
  null
  
)

export default component.exports